import React, { useEffect, useState } from "react";
import TimeoutModal from "../../components/Modal/Timeout";
import sessionImg from "../../assets/session.jpg";

interface Props {
  visible: boolean;
  secondsLeft: number;
  onExtend: () => void;
  onLogout: () => void;
}

const SessionTimeoutModal: React.FC<Props> = ({
  visible,
  secondsLeft: initialSecondsLeft,
  onExtend,
  onLogout,
}) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSecondsLeft);

  useEffect(() => {
    if (!visible) return;
    setSecondsLeft(initialSecondsLeft);

    const interval = window.setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [visible, initialSecondsLeft, onLogout]);

  if (!visible) return null;

  return (
    <TimeoutModal
      isVisible={visible}
      content={
        <div className="timeoutContainer">
          <div className="popupTimeout">
            <img src={sessionImg} alt="session timeout" />
          </div>
          <h3>Your session is about to expire</h3>
          <p>You will be logged out in {secondsLeft} seconds.</p>
          <br />
          <div className="btnContainer">
            <button onClick={onLogout} className="btn greenOutline">
              Logout
            </button>
            <button onClick={onExtend} className="btn green">
              Extend Session
            </button>
          </div>
        </div>
      }
    />
  );
};

export default SessionTimeoutModal;
